import { PredefinedTraits } from "~/features/productDetails/components/ProductTrait";
import {
  AliasesParameter,
  CountryOfOriginDescriptorParam,
  LinearConfigParameter,
  OldDesignationParameter,
  SchaefflerIdParameter,
  TariffParameter,
} from "~/domains/product/components/ProductParams";
import { NewVersionMessage } from "../../../../common/components/Messages/NewVersionMessage";
import { isKITProduct } from "~/domains/product/types/ProductData";
import { HousingMessages } from "~/domains/housing/components/HousingMessages";
import { useTranslation } from "react-i18next";

import { ProductDescriptorContext } from "~/domains/product/ProductContext";
import { Product } from "~/domains/product/Product";
import { getIsContractAvailable } from "~/features/productDetails/redux/productDetailsSelectors";
import { FCCTag } from "~/features/freeCapacityPush/components/FCCTag/FCCTag";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { Stack } from "~/common/mui";

interface Props {
  productDescriptor: ProductDescriptor;
  isFcc: boolean;
}

const CartEntryProductInfo = ({ productDescriptor, isFcc }: Props) => {
  const { t } = useTranslation();

  const data = productDescriptor.base;
  const isContractProduct = getIsContractAvailable(productDescriptor);

  const isKIT = isKITProduct(data);

  return (
    <ProductDescriptorContext value={productDescriptor}>
      <Stack gap={1} sx={{ alignItems: "flex-start" }}>
        <Product.PrimaryImageWithLogos size={"small"} />
        {isKIT && <HousingMessages.NotFinal className={"mt-2"} />}

        <Product.FullDesignation className={"title-medium f-bold"} />
        <Product.MMDTag />
        <Product.ShortDescription clickable={false} />

        {isFcc && <FCCTag />}

        <NewVersionMessage className={"mt-2"} baseProduct={data} />
        <Stack gap={1} sx={{ mt: 1 }}>
          <LinearConfigParameter label={t("cartPage.systemLayout.label")} />
          <OldDesignationParameter data-test-id={"old-designation"} label={t("productDetailPage.oldDesignation")} />
          <SchaefflerIdParameter data-test-id={"schaeffler-id"} />
          <AliasesParameter mode={"13-digits"} />
          <TariffParameter />
          {/* <CountryOfOriginParam product={productDescriptor.base} /> */}
          <CountryOfOriginDescriptorParam />
        </Stack>

        {isContractProduct && <PredefinedTraits.ContractProduct />}
      </Stack>
    </ProductDescriptorContext>
  );
};
export default CartEntryProductInfo;
